var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-button-group',{attrs:{"value":_vm.value,"narrow":"","new-design":"","dataforce":"","options":_vm.trafficSources},on:{"input":function($event){return _vm.updateUrl({traffic_source: $event})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }